import { Injectable } from "@angular/core";

import {
  CreateEventDto,
  CustomerDto,
  EventDto,
  FindCustomerEventDto,
  FindEventDto,
  PageResultDto,
  UpdateEventDto,
} from "../dto";

import { HttpService } from "./http.service";

const EVENT_URL = "/admin/v1/events";

@Injectable()
export class AdminEventService {
  constructor(private httpService: HttpService) { }

  async find(findEventDto: FindEventDto) {
    return await this.httpService.get<PageResultDto<EventDto>>(
      EVENT_URL,
      findEventDto
    );
  }

  async create(createTenantCategoryDto: CreateEventDto) {
    return await this.httpService.post<EventDto>(
      EVENT_URL,
      createTenantCategoryDto
    );
  }

  async findOne(id: string) {
    return await this.httpService.get<EventDto>(`${EVENT_URL}/${id}`);
  }

  async update(id: string, updateTenantCategoryDto: UpdateEventDto) {
    return await this.httpService.patch<Boolean>(
      `${EVENT_URL}/${id}`,
      updateTenantCategoryDto
    );
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`${EVENT_URL}/${id}`);
  }

  async findCustomers(id: string, findCustomerEventDto: FindCustomerEventDto) {
    return await this.httpService.get<PageResultDto<CustomerDto>>(
      `${EVENT_URL}/${id}/customers`,
      findCustomerEventDto
    );
  }

  async exportCustomers(id: string, findCustomerEventDto: FindCustomerEventDto) {
    return await this.httpService.downloadBlob<Blob>(
      `${EVENT_URL}/${id}/customers/export`,
      findCustomerEventDto
    );
  }

  async enabledEvent(id: string, displayStatus: boolean) {
    return await this.httpService.patch<Boolean>(
      `${EVENT_URL}/${id}/display-status`,
      { displayStatus }
    );
  }
}
